import { createChat } from "../api/chatApi.js";

export const createNewChat = async (setActiveChat, datasetId) => {
  const response = await createChat(datasetId);
  const { data } = response;
  setActiveChat(data.id);
  return data?.id;
};
